import React from "react";
import "./Loading.scss";
import loadingArtwork from '../../images/C247Logo2023.gif';

const LoadingSpinner = ({ loading }) => {
    if (!loading) return null;

    return (
        <div className="modal-loading">
            <img src={loadingArtwork} alt="Loading" />
        </div>
    );
};

export default LoadingSpinner;